import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { GlobalParameter } from '../factory/global-parameter';
import { Metamodel } from 'app/model/base/model';
import { AdapterContext, generateIdentity, NamedAdapter, Parameter, setIdentity } from 'shell-models-lib';
import { convertParameterValue, stringifyParameterValue } from 'app/shared/utils/parameter-converter.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GlobalParameter)
})
export class GlobalParameterAdapter extends NamedAdapter<Parameter, Model.GlobalParameterSpecification> {

    protected _toResource(parameter: Parameter): Model.GlobalParameterSpecification {
        const parameterSpecification: Model.GlobalParameterSpecification = {
            type: parameter._type
        };
        if (parameter.defaultValue !== undefined) {
            const doNotParseValueIntoObject = parameter._type === 'securestring';
            parameterSpecification.value = 
                parameter._type === 'securestring' && parameter.defaultValue === '' ? '' : convertParameterValue(parameter.defaultValue, parameter._type, 'GlobalParameterAdapter', this.getNullableLogger(), doNotParseValueIntoObject);
        }

        if (this.context.writeIdentities) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (parameterSpecification as any).identity = this.context.identityProvider.identity(parameter);
        }
        return parameterSpecification;
    }

    protected _toModel(modelParameter: Model.GlobalParameterSpecification, parameter?: Parameter, parameterName?: string, ownerType?: string, ownerName?: string): Parameter {
        if (!parameter) {
            parameter = new Parameter(parameterName);
        }
        // eslint-disable-next-line
        if (modelParameter.value !== undefined) {
            parameter.defaultValue = stringifyParameterValue(modelParameter.value);
        }
        parameter._type = modelParameter.type;

        if (this.context.adapterConfig.replaceIdentitiesForNonConcepts) {
            // If we are getting these assertion we have to fix the calling code.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const parameterIdentity = AdapterContext.getIdentity(generateIdentity(ownerType, ownerName), parameter.name!);

            setIdentity(parameter, parameterIdentity);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const resource = modelParameter as any;
            if (resource.identity) {
                setIdentity(parameter, resource.identity);
            }
        }

        return parameter;
    }
}
